var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "div",
        {
          staticClass:
            "bg-white overflow-hidden shadow rounded-lg max-w-xl mx-auto mt-10"
        },
        [
          _c("div", { staticClass: "px-4 py-5 sm:p-6 " }, [
            _c("p", { staticClass: "text-sm font-semibold" }, [
              _vm._v(" Please follow the steps below to get started ")
            ]),
            _c("div", { staticClass: "flex flex-col" }, [
              _c("img", {
                staticClass:
                  "my-4  object-contain border border-gray-300 rounded-md",
                attrs: { src: require("../assets/onboarding/onboarding_1.png") }
              }),
              _c("img", {
                staticClass:
                  "my-4  object-contain border border-gray-300 rounded-md",
                attrs: { src: require("../assets/onboarding/onboarding_2.png") }
              }),
              _c("img", {
                staticClass:
                  "my-4  object-contain border border-gray-300 rounded-md",
                attrs: { src: require("../assets/onboarding/onboarding_3.png") }
              }),
              _c("img", {
                staticClass:
                  "my-4  object-contain border border-gray-300 rounded-md",
                attrs: { src: require("../assets/onboarding/onboarding_4.png") }
              })
            ])
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }